const size = {
  desktopMaxWidth: '1440px',
  desktopMedWidth: '1280px',
  desktopWidth: '1037px',
  desktopMinWidth: '992px',
  tabletMaxWidth: '790px',
  tabletMinWidth: '670px',
  mobileMaxWidth: '540px',
  mobileMinWidth: '480px',
};

export const media = {
  desktopMax: `(min-width: ${size.desktopMaxWidth})`,
  desktopMed: `(min-width: ${size.desktopMedWidth})`,
  desktop: `(min-width: ${size.desktopWidth})`,
  desktopMin: `(min-width: ${size.desktopMinWidth})`,
  tabletMax: `(min-width: ${size.tabletMaxWidth})`,
  tabletMin: `(min-width: ${size.tabletMinWidth})`,
  mobileMax: `(min-width: ${size.mobileMaxWidth})`,
  mobileMin: `(min-width: ${size.mobileMinWidth})`,
};
